import { isEthereumLike } from '@exodus/ethereum-lib';
import ExodusModule from '@exodus/module';
const MODULE_ID = 'exchangeFees';
export class ExchangeFees extends ExodusModule {
    #ethereumLike;
    #exchangeAssets;
    #fees;
    #feeMonitors;
    constructor(params) {
        super({ MODULE_ID });
        if (!params.fees && !params.ethereumLike) {
            throw new Error('At least fees or ethereumLike dependency is required');
        }
        this.#exchangeAssets = params.exchangeAssets;
        this.#ethereumLike = params.ethereumLike;
        this.#fees = params.fees;
        this.#feeMonitors = params.feeMonitors;
    }
    getFeeOpts = async (params) => {
        const asset = this.#exchangeAssets.getAsset({ assetId: params.assetId });
        if (this.#fees) {
            const feeData = await this.#feeMonitors.getFeeData({ assetName: asset.baseAsset.name });
            const fees = await this.#fees.getFees({
                assetName: asset.name,
                ...params,
            });
            return { ...feeData, ...fees };
        }
        if (!isEthereumLike(asset)) {
            const fee = await this.#feeMonitors.getFeeData({ assetName: asset.baseAsset.name });
            return { fee: fee.fee || asset.currency.ZERO };
        }
        return this.#ethereumLike.getFeeOpts({
            ...params,
            toAddress: params.toAddress || '0xffffffffffffffffffffffffffffffffffffffff',
            sendAmount: params.amount.toDefaultString({ unit: false }),
            assetName: asset.name,
        });
    };
    getFees = async (params) => {
        const asset = this.#exchangeAssets.getAsset({ assetId: params.assetId });
        try {
            if (this.#fees) {
                const fee = await this.#fees.getFees({
                    assetName: asset.name,
                    ...params,
                });
                return fee.fee;
            }
            if (!isEthereumLike(asset)) {
                return asset.feeAsset.currency.ZERO;
            }
            const feeData = await this.#feeMonitors.getFeeData({ assetName: asset.baseAsset.name });
            return feeData.gasPrice.mul(params.gasLimit || 0);
        }
        catch (err) {
            console.error('Failed to get fees', err);
            return asset.feeAsset.currency.ZERO;
        }
    };
}
const exchangeFeesFactory = (args) => new ExchangeFees({ ...args });
const exchangeFeesModuleDefinition = {
    id: MODULE_ID,
    type: 'module',
    factory: exchangeFeesFactory,
    dependencies: ['ethereumLike?', 'exchangeAssets', 'feeMonitors', 'fees?'],
};
export default exchangeFeesModuleDefinition;
